<template>
  <q-btn
    v-bind="$attrs"
    icon="fas fa-location-crosshairs"
    :label="!iconOnly ? $t('siteLocation.actions.useCurrentLocation') : undefined"
    data-test-id="use-current-location-button"
    @click="getCurrentLocation"
  >
    <q-tooltip v-if="iconOnly">
      {{ $t('siteLocation.actions.useCurrentLocation') }}
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  name: 'UseCurrentLocationButton',
  props: {
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['current-location-request', 'current-location-response'],

  methods: {
    getCurrentLocation () {
      this.$emit('current-location-request')
      try {
        navigator.geolocation.getCurrentPosition(this.handleCurrentLocationResult, this.handleCurrentLocationError)
      } catch (error) {
        this.$mh.showErrors(error)
        this.$emit('current-location-response', null)
      }
    },
    handleCurrentLocationResult (position) {
      const origin = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude)
      this.$emit('current-location-response', origin)
    },
    handleCurrentLocationError (error) {
      this.$mh.showErrors(error)
      this.$emit('current-location-response', null)
    }
  }
}
</script>
